<template>
  <v-menu
    ref="menu"
    v-model="showPicker"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    absolute
    offset-y
    offset-x
  >
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <v-text-field
          :id="id"
          v-model="dateTime"
          :messages="messages"
          :label="label"
          :error="errorMessages.length > 0"
          :error-message="errorMessages"
          clearable
          flat
          hide-details
          readonly
          :class="customClass"
          :clear-icon="$getIcon('mdiClose')"
          :prepend-inner-icon="$getIcon('mdiClockOutline')"
          @click:append="resetDateTime"
          @input="$emit('blur')"
        ></v-text-field>
        <span v-if="errorMessages.length > 0" class="danger--text">
          {{ errorMessages[0] }}
        </span>
      </div>
    </template>
    <v-card>
      <v-responsive width="200">
        <div>
          <div class="text-center font-weight-black pa-2">
            Time
          </div>
        </div>
        <v-divider></v-divider>
        <v-row id="time-picker" class="d-flex mx-3" no-gutters>
          <v-col>
            <v-text-field v-model="hour" mask="##"></v-text-field>
          </v-col>
          <v-col class="text-center">
            <div class="mt-6" v-text="':'"></div>
          </v-col>
          <v-col>
            <v-text-field v-model="minute" mask="##"></v-text-field>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row align="center" justify="center" no-gutters>
          <v-col class="text-center">
            <div>
              <v-btn icon @click="changeHour('increment')">
                <v-icon v-text="$getIcon('mdiChevronUp')"> </v-icon>
              </v-btn>
            </div>
            <v-btn icon>
              {{ hour }}
            </v-btn>
            <div>
              <v-btn icon @click="changeHour('decrement')">
                <v-icon v-text="$getIcon('mdiChevronDown')"> </v-icon>
              </v-btn>
            </div>
          </v-col>
          <span v-text="':'"></span>
          <v-col class="text-center">
            <div>
              <v-btn icon @click="changeMinute('increment')">
                <v-icon v-text="$getIcon('mdiChevronUp')"> </v-icon>
              </v-btn>
            </div>
            <v-btn icon>
              {{ minute }}
            </v-btn>
            <div>
              <v-btn icon @click="changeMinute('decrement')">
                <v-icon v-text="$getIcon('mdiChevronDown')"> </v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-responsive>
    </v-card>
  </v-menu>
</template>
<script>
export default {
  props: {
    placeHolder: {
      type: String,
      required: false,
      default() {
        return "HH:MM:SS";
      }
    },
    messages: {
      type: Array,
      required: false,
      default() {
        return [];
      }
    },
    value: {
      type: String,
      default: undefined
    },
    id: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    errorMessages: {
      type: [String, Array],
      default() {
        return [];
      }
    },
    customClass: {
      type: [String],
      default: ""
    },
    defaultValue: {
      validator: function(value) {
        // The value must be HH:MM
        let time = value.split(":");
        return (
          time.length === 2 && time[0].length === 2 && time[1].length === 2
        );
      },
      type: String,
      required: false
    }
  },
  data: () => ({
    showPicker: false,
    menu: false,
    date: "",
    dateTime: "",
    hour: "",
    minute: "",
    seconds: "00"
  }),
  computed: {
    time() {
      if (!this.hour || !this.minute) return "";
      return this.hour + ":" + this.minute;
    }
  },
  watch: {
    value(val) {
      this.dateTime = val;
    },
    hour(val) {
      val = parseInt(val);
      if (val > 23) this.hour = 23;
      if (val < 0) this.hour = 23;
      this.setDate();
      if (
        val.toString() !== "00" &&
        val.toString() !== "0" &&
        isNaN(val) === false
      ) {
        setTimeout(() => {
          this.hour =
            (this.hour < 10 && this.hour.toString().length < 2 ? "0" : "") +
            this.hour.toString();
        }, 1000);
      }
    },
    minute(val) {
      val = parseInt(val);
      if (val > 59) this.minute = 59;
      if (val < 0) this.minute = 0;
      this.setDate();
      if (
        val.toString() !== "00" &&
        val.toString() !== "0" &&
        isNaN(val) === false
      ) {
        setTimeout(() => {
          this.minute =
            (this.minute < 10 && this.minute.toString().length < 2 ? "0" : "") +
            this.minute.toString();
        }, 1000);
      }
    },
    dateTime(val) {
      // if (val) {
      this.$emit("input", val);
      // }
    },
    showPicker(val) {
      if (this.dateTime || !val) return;
      if (this.defaultValue) {
        this.hour = this.defaultValue.split(":")[0];
        this.minute = this.defaultValue.split(":")[1];
      } else if (!this.dateTime) {
        this.hour = this.$dayjs().format("HH");
        this.minute = this.$dayjs().format("mm");
        this.setDate();
      }
    }
  },
  created() {
    if (this.value) {
      this.hour = this.value.split(":")[0];
      this.minute = this.value.split(":")[1];
    }
  },
  methods: {
    changeHour(action) {
      this.hour = parseInt(this.hour);
      if (action === "increment") {
        if (this.hour === 23) this.hour = 0;
        else this.hour += 1;
      } else {
        if (this.hour === 0) this.hour = 23;
        else this.hour -= 1;
      }
    },
    changeMinute(action) {
      this.minute = parseInt(this.minute);
      if (action === "increment") {
        if (this.minute === 59) {
          this.minute = 0;
          this.changeHour("increment");
        } else this.minute += 1;
      } else {
        if (this.minute === 0) {
          this.minute = 59;
          this.changeHour("decrement");
        } else this.minute -= 1;
      }
    },
    setDate() {
      this.dateTime = this.time || "";
    },
    resetDateTime() {
      this.showPicker = false;
      this.dateTime = "";
      this.$emit("click:append");
    }
  }
};
</script>
<style>
#time-picker input {
  text-align: center !important;
}
</style>
